(function() {
  'use strict';

  function Search($translate, moment) {
    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'name',
              type: 'search',
              label: $translate.instant('Start typing to search')
            }
          ],
          options: {
            defaultFacet: 'name',
            placeholder: $translate.instant('Start typing to search...'),
            listMaxItems: 10
          }
        },
        filters: [
          {
            id: 'name',
            matchFunc: function(doc, _key, value) {
              if (!value) { return true; }

              var val = value.toLowerCase(),
                  name = doc.doc.name.toLowerCase();
              return name.indexOf(val) > -1;
            }
          }
        ],
        orders: {
          name: function(item) {
            return item.doc.name.toLowerCase();
          },
          importance: function(item) {
            return item.doc.order;
          },
          added: function(item) {
            var dt = item.doc.createdDate;
            if (dt === undefined && item.doc.dates && item.doc.dates.length) {
              dt = item.doc.dates[0].date;
            }
            if (dt === undefined) {
              return Number.MAX_SAFE_INTEGER;
            }
            return -(moment(dt).toDate().getTime());
          },
          modified: function(item) {
            var dt = item.doc.modifiedDate;
            if (dt === undefined && item.doc.dates && item.doc.dates.length) {
              dt = _.last(item.doc.dates).date;
            }
            if (dt === undefined) {
              return Number.MAX_SAFE_INTEGER;
            }
            return -(moment(dt).toDate().getTime());
          }
        },
        orderGroups: {
          name: {
            title: $translate.instant('name'),
            orders: ['name']
          },
          importance: {
            title: $translate.instant('Importance'),
            orders: ['importance']
          },
          added: {
            title: $translate.instant('added'),
            orders: ['added', 'name']
          },
          modified: {
            title: $translate.instant('most recent'),
            orders: ['modified', 'name']
          }
        },
        defaultFilter: {
        },
        defaultOrder: 'importance'
      };
      return search;
    };

    var service = {
      search: getSearch()
    };

    return service;
  }

  Search.$inject = ['$translate', 'moment'];

  angular.module('component.relations')
    .service('RelationSearch', Search);
})();
